/**
 * Created by alvinoktavianus on 6/27/17.
 */

import React, { Component } from 'react'

import styles from './FeatureTutorialPage.css'

class FeatureTutorialPage extends Component {
  render () {
    const {featureName, isSubscribedAccount, videoLink, endTutorial} = this.props
    const message = `Thank you for ${isSubscribedAccount ? 'purchasing' : 'trying'} Moka’s Ingredient Inventory. Here’s the tutorial to show you how it works.`

    return (
      <div className={styles['splash-page']}>
        <div className={styles['splash-content']}>
          <h3 className={`text-center ${styles['splash-title']}`}>{featureName}</h3>
          <p className={styles['ingredients-description']}>{message}</p>
          <p className={`text-center ${styles['splash-video']}`}>
            <iframe width='248' height='167' src={videoLink} frameBorder={0} allowFullScreen id='video' />
          </p>
          <button className={`btn btn-primary btn-block ${styles['btn-use-ingredients']}`} onClick={endTutorial}>
            <strong>Got it!</strong>
          </button>
        </div>
      </div>
    )
  }
}

FeatureTutorialPage.propTypes = {
  featureName: React.PropTypes.string,
  isSubscribedAccount: React.PropTypes.bool,
  videoLink: React.PropTypes.string,
  endTutorial: React.PropTypes.func
}

export default FeatureTutorialPage



// WEBPACK FOOTER //
// ./app/components/FeatureTutorialPage/FeatureTutorialPage.js